import mapInterface from '../mapboxgl/mapInterface';

const getStopMarkerCoords = (stops, stopIds) => {
  return stopIds.reduce((acc, id) => {
    if (stops[id]) {
      if (stopIds.length > 1) {
        const { lng, lat } = stops[id];
        acc.push([lng, lat]);
      } else {
        const { lng, lat } = stops[id];
        acc[0] = lng;
        acc[1] = lat;
      }
    }
    return acc;
  }, []);
};

export const setNewMapBounds = (stops, stopIds, padding = 75, zoom) => {
  const coords = getStopMarkerCoords(stops, stopIds);
  if (coords.find(x => typeof x === 'object')) {
    const bounds = mapInterface.setNewMapBounds(coords);
    const options = {
      padding,
    };
    if (zoom) {
      options.zoom = zoom;
    }
    mapInterface.getMap().fitBounds(bounds, options);
  } else {
    coords && mapInterface.getMap().panTo(coords, { zoom: zoom || 10 });
  }
};
